import { useSelector } from 'react-redux'
import {
  selectPrefersCrmContactsPageEnabled,
  selectPrefersAiDraftsReady,
  selectPrefersAiOverviewReady,
  selectPrefersHelplyAgentReady,
} from 'selectors/app/selectAccountPreferences'

const FEATURE_SELECTORS = {
  'crm-contacts-page-enabled': selectPrefersCrmContactsPageEnabled,
  'ai-drafts-ready': selectPrefersAiDraftsReady,
  'ai-overview-ready': selectPrefersAiOverviewReady,
  'helply-agent-ready': selectPrefersHelplyAgentReady,
}

const useAccountFeatureFlag = featureName => {
  const selector = FEATURE_SELECTORS[featureName]
  if (!selector) throw new Error(`Unknown feature flag: ${featureName}`)
  return useSelector(selector)
}

export default useAccountFeatureFlag
